/**
 * TK Modal Color Map - for Quick Add Modal swatches
 * Extracted from blanks-product colorMap, used when blanks-product.js is not loaded
 */
window.TK_COLOR_MAP = window.TK_COLOR_MAP || Object.assign({
  "Aqua": "rgb(66, 152, 181)",
  "Baby Blue": "rgb(131, 176, 193)",
  "Black": "rgb(0, 0, 0)",
  "Caribbean": "rgb(83, 196, 203)",
  "Caribbean Blue": "rgb(0, 169, 206)",
  "Charcoal": "rgb(54, 69, 79)",
  "Charity Pink": "rgb(223, 103, 151)",
  "Graphite Heather": "rgb(112, 115, 114)",
  "Heather Blue": "rgb(142, 159, 188)",
  "Heather Dark Grey": "rgb(112, 114, 115)",
  "Heather Grey": "rgb(176, 178, 179)",
  "Heather Navy": "rgb(47, 53, 80)",
  "Heather Navy Blue": "rgb(54, 69, 92)",
  "Navy": "rgb(0, 0, 128)",
  "Royal Blue": "rgb(30, 93, 182)",
  "Royal": "rgb(34, 77, 143)",
  "Smoke": "rgb(88, 81, 78)",
  "Sport Grey": "rgb(151, 153, 155)",
  "Storm Grey": "rgb(130, 132, 135)",
  "Teal Ice": "rgb(180, 220, 210)",
  "True Red": "rgb(187, 22, 33)",
  "White": "rgb(255, 255, 255)",
  "Charcoal Heather": "rgb(74, 80, 89)",
  "Heather Charcoal": "rgb(74, 80, 89)",
  "Light Grey": "rgb(197, 191, 186)",
  "Dark Heather Grey": "rgb(112, 114, 115)",
  "Daisy": "rgb(250, 207, 68)",
  "Forest Green": "rgb(34, 139, 34)",
  "Light Blue": "rgb(164, 200, 225)",
  "Red": "rgb(208, 45, 45)",
  "Sand": "rgb(194, 178, 128)",
  "Sapphire": "rgb(9, 132, 184)"
}, window.TK_COLOR_MAP || {});

function tkMergeVariantSwatches() {
  var vs = window.VARIANT_SWATCHES;
  if (!vs || !window.TK_COLOR_MAP) return;
  Object.keys(vs).forEach(function(k) {
    if (window.TK_COLOR_MAP[k]) return;
    var v = vs[k];
    if (v.hex) {
      window.TK_COLOR_MAP[k] = v.hex;
    } else if (v.img) {
      window.TK_COLOR_MAP[k] = { image: v.img };
    }
  });
}
tkMergeVariantSwatches();
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', function() { setTimeout(tkMergeVariantSwatches, 50); });
} else {
  setTimeout(tkMergeVariantSwatches, 50);
}
